import type { FunctionComponent } from 'react';
import CountUp from 'react-countup';

interface Props {
	from?: number;
	to: number;
	/**
	 * Animation delay in seconds
	 */
	animationDelay?: number;
}

const Counter: FunctionComponent<Props> = (props: Props) => {
	const { from = 0, to, animationDelay } = props;

	return (
		<CountUp
			key={to}
			start={from}
			end={to}
			delay={animationDelay}
			duration={2}
			useEasing={false}
		/>
	);
};

export default Counter;
